import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  COUNTRY_OF_MFG,
  EAR99,
  EUROPEAN_COMMERCE_CONTROL_NUMBER,
  HAZMAT,
  SCHEDULE_B_OR_HT_CODE,
  SNCHK
} from "MODULES/parts/constants";
import {
  CITY,
  COMPANY_NAME,
  CONTACT_EMAIL,
  COUNTRY,
  CUSTOMER_PO,
  LINE1,
  LINE_ITEMS,
  POSTAL_CODE,
  ULTIMATE_CONSIGNEE_ADDRESS,
  FREIGHT_FORWARDER_ADDRESS,
  COMPANY_ID,
  STATE
} from "APP_ROOT/constants";
import {
  CONSIGNEE,
  EIN,
  ROUTED_EXPORT,
  USPPI
} from "MODULES/Shipping/constants";
import {
  CARGO_SCREENING_CONSENT,
  LICENSE_REQUIRED
} from "MODULES/shared/components/CommercialInvoice/constants";
import get from "lodash/get";

function validateItem(item, values) {
  item
    .validate(SCHEDULE_B_OR_HT_CODE)
    .satisfies(rules.required, rules.matchesPattern(/\d{4}\.\d{2}\.\d{2,4}/));

  if (![EAR99, SNCHK].includes(values[EUROPEAN_COMMERCE_CONTROL_NUMBER])) {
    item
      .validate(EUROPEAN_COMMERCE_CONTROL_NUMBER)
      .satisfies(
        rules.matchesPattern(/^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/)
      );
  }

  item
    .validate(COUNTRY_OF_MFG, EUROPEAN_COMMERCE_CONTROL_NUMBER)
    .satisfies(rules.required);

  item.validate(LICENSE_REQUIRED).satisfies(rules.isBool);
}

export default function(values) {
  return validator(values, form => {
    form.validate(CONSIGNEE, CUSTOMER_PO, EIN).satisfies(rules.required);

    form
      .validate(ROUTED_EXPORT, USPPI, CARGO_SCREENING_CONSENT)
      .satisfies(rules.isBool);

    form.validate(HAZMAT).satisfies(rules.isBool);
    form.validate(CONTACT_EMAIL).satisfies(rules.isValidEmail);
    form.validateChild(FREIGHT_FORWARDER_ADDRESS, method => {
      if (
        [null, undefined].includes(
          get(values, "freight_forwarder_address.company_name")
        )
      ) {
        method.validate(COMPANY_ID).satisfies(rules.required);
      } else {
        [COMPANY_NAME, COUNTRY, LINE1, CITY].forEach(f =>
          method.validate(f).satisfies(rules.required)
        );

        if (get(values, "freight_forwarder_address.country") === "US") {
          [STATE, POSTAL_CODE].forEach(f =>
            method.validate(f).satisfies(rules.required)
          );
        }
      }
    });

    form.validateChild(ULTIMATE_CONSIGNEE_ADDRESS, method => {
      method
        .validate(COMPANY_NAME, COUNTRY, LINE1, CITY, POSTAL_CODE)
        .satisfies(rules.required);
    });

    form.validateChildren(LINE_ITEMS, validateItem);
  });
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/validate.js